export const substituteAndSplitEmailTemplate = (
  emailTemplate: string,
  substitutions: {
    find: string;
    replaceWith: string;
  }[]
) => {
  let substitutedTemplate = emailTemplate;

  substitutions?.forEach((substitution) => {
    substitutedTemplate = substitutedTemplate.replaceAll(
      `[${substitution.find}]`,
      substitution.replaceWith
    );
  });

  let splitTemplate: string[];
  if (substitutedTemplate.includes('\n[button]\n')) {
    splitTemplate = substitutedTemplate.split('\n[button]\n');
  } else {
    splitTemplate = substitutedTemplate.split('[button]');
  }

  return {
    preButton: splitTemplate[0] || '',
    postButton: splitTemplate[1] || '',
  };
};
